import CustomizedButtons from "../../../commonComponents/Button";
import Logo from "assets/images/club-car-connect-logo.png";
import {
  Container,
  PageTitle,
  InputBoxWrapper,
  Wrapper,
} from "../UserAuthStyled";
// functional imports
import React, { useState, useEffect } from "react";
//  material UI imports starts
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
// redux imports starts
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

// redux imports ends

// import axios from "axios";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "calc(100% -  40px)",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
};

export const ForgetUsername = (props) => {
  const dispatch = useDispatch();
  // modal design starts
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState({
    email: false,
    incorrect: false,
  });
  const handleClick = async (e) => {
    e.preventDefault();

    // setResMsg("")
    if (email !== "") {
      // dispatch(
      //   COMMON_SERVICES.resetUsernameServices({ email: email }, navigate)
      // );
      await dispatch(COMMON_SERVICES.resetUsernameServices(email));

      // setOpen(true);
    } else {
      setError({ email: true });
      // alert("Please enter email");
    }
  };

  // useEffect(() => {
  //   handleClick();
  // }, []);

  const handleClose = () => setOpen(false);

  const [resMsg, setResMsg] = useState("");
  const { resetUsernameData, resetUsernameStatus } =
    useSelector((state) => state.commonReducers) || "";

  useEffect(() => {
    if (resetUsernameStatus === "success") {
      setResMsg(resetUsernameData);
    }
  }, [resetUsernameStatus]);

  useEffect(() => {
    if (resMsg !== "") {
      resMsg === "User does not exist with entered email address."
        ? setError({ incorrect: true })
        : setOpen(true);
    }
  }, [resMsg]);

  // modal design ends
  return (
    <Container>
      <img src={Logo} alt="logo" className="logo" />
      <Wrapper>
        <PageTitle>Forgot Username</PageTitle>
        <form onSubmit={handleClick}>
          <InputBoxWrapper>
            <p>Enter your email address</p>

            <input
              type="email"
              name="email"
              label="Enter your email address"
              htmlFor="Enter your email here"
              placeholder="Enter your email here"
              onChange={(e) => {
                setEmail(e.target.value);
                setError({ email: false, incorrect: false });
              }}
              value={email}
            />
            {error.email && <div className="error">Please Enter Email</div>}
          </InputBoxWrapper>

          <div className="error">{error.incorrect && resMsg}</div>
          {/* <button onClick={handleClick}
                     type='submit'
                    >submit</button> */}

          <CustomizedButtons
            title="Submit"
            type="submit"
          //    onClick={handleClick}
          />
          <span
            onClick={() => (window.location.href = "/")}
            className="bottom-span"
          >
            Back to Login Page
          </span>
        </form>
      </Wrapper>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
      // closeAfterTransition
      // BackdropComponent={Backdrop}
      // BackdropProps={{
      //   timeout: 500,
      // }}
      >
        <Fade in={open}>
          <Box sx={style}>
            {/* <Typography id="transition-modal-title" variant="h6" component="h2"> */}

            {/* {(resMsg === "") && <CircularProgress />} */}
            {/* {(resMsg==="User does not exist with entered email address.") && 
            <GppBadIcon color="error" fontSize="large"  /> } */}
            {/* {(resMsg!=="User does not exist with entered email address." && resMsg !== "") && 
            <img src={modal1} /> } */}

            {/* </Typography> */}
            <Typography
              style={{ textAlign: "center", wordBreak: 'break-word' }}
              id="transition-modal-description"
              sx={{ mt: 2 }}
            >
              {resMsg}
              {/* Username has been sent successfully to your Email Address */}
            </Typography>
            {/* {(resetDataInfo!=="User does not exist with entered email address.") && */}
            <Button
              variant="contained"
              className="button-Modal"
              style={{
                marginTop: "1.5rem",
                backgroundColor: "var(--theme-background)",
                color: "#fff",
                fontSize: "14px",
                fontWeight: "500",
                minWidth: "187px",
                boxShadow: "none",
                height: "41px",
                borderRadius: "40px",
              }}
              // onClick={() => navigate(-1)}
              onClick={() => (window.location.href = "/")}
            >
              Proceed to Login
            </Button>
            {/* } */}
          </Box>
        </Fade>
      </Modal>
    </Container>
  );
};

// export default ForgetUsername;
